import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ChevronLeftIcon } from "lucide-react";
import carIcon from "@/assets/icons/CarIcon.svg";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@/themeConfigs/ThemeContext";

type Props = {
  text: string;
  color: string;
  number?: string;
};

const TopBar = (props: Props) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { text = "", color, number = "" } = props;
  return (
    <div className="flex flex-row items-center space-x-4">
      {theme.layout.backButton && (
        <Button
          variant="icon"
          className={`rounded-lg border-2  hover:shadow-lg h-16 px-2 py-7 flex items-center justify-center`}
          style={{ borderColor: color, color: color }}
          onClick={() => navigate("/home")}
        >
          <ChevronLeftIcon />
        </Button>
      )}

      {/* Main Card */}
      <Card
        className={`flex flex-grow items-center rounded-lg border-2  shadow-md hover:shadow-lg h-16`}
        style={{ borderColor: color }}
      >
        <CardContent className="grid grid-cols-12 items-center gap-4 py-3">
          <div className="col-span-2 flex justify-center">
            <img src={carIcon} alt="Car Icon" className="w-9 h-9" />
          </div>
          <div className="col-span-8 flex justify-center">
            <h2 className={`text-md tracking-tight`} style={{ color: color }}>
              {text}
            </h2>
          </div>
          <div className="col-span-2 flex justify-center">
            <h1
              className={`text-4xl font-extrabold tracking-tight`}
              style={{ color: color }}
            >
              {number}
            </h1>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TopBar;
